import { DateRangePicker } from '@repo/ui/DateRangePicker';
import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { SelectorInputField, TextInputField } from '@repo/ui/Form';
import { registerDateRange, registerInput } from '@repo/hooks/useZodForm';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';

import { useFormState } from 'react-hook-form';
import type { SelectInputOptions } from '@repo/types/Types';

interface SubAccountsTableFilterProps {
  SORT_OPTIONS: SelectInputOptions;
}

const SubAccountsTableFilter = ({ SORT_OPTIONS }: SubAccountsTableFilterProps) => {
  const filter = useZodFormContext();
  useFormState();
  if (!filter) {
    return <></>;
  }
  return (
    <TableFilterCard>
      <TableFilterSection>
        <TextInputField label="Name" {...registerInput(filter, 'name')} />
        <TextInputField label="Customer ID" {...registerInput(filter, 'customer_id')} />
        <SelectorInputField
          label="Sort by"
          options={SORT_OPTIONS}
          {...registerInput(filter, 'sort')}
        />
      </TableFilterSection>

      <TableFilterButtons className="self-end" />
    </TableFilterCard>
  );
};

export default SubAccountsTableFilter;
